import { ItiBaseDto } from '@/iti-core-vue';
import { Field } from './field';
import { Categories } from './categories';
import { TemplateVersion } from './template-version';

export class Template extends ItiBaseDto {
    public title!: string;
    public description!: string;
    public active!: boolean;
    public offer!: boolean;
    public demand!: boolean;
    public categories!: Categories;
    // public categoriesCategoryFirstLevelId !: number; 
    // public categoriesCategoryFirstLevelCode !: string; 
    // public categoriesCategoryFirstLevelDescription !: string; 
    // public categoriesCategorySecondLevelId !: number; 
    // public categoriesCategorySecondLevelCode !: string; 
    // public categoriesCategorySecondLevelDescription !: string;
    // public categoriesCategoryThirdLevelId !: number; 
    // public categoriesCategoryThirdLevelCode !: string;
    // public categoriesCategoryThirdLevelDescription !: string;
    // public categoriesCategoryFourthLevelId !: number; 
    // public categoriesCategoryFourthLevelCode !: string; 
    // public categoriesCategoryFourthLevelDescription !: string; 

    public templateVersions!: TemplateVersion[];
}